module.exports = __webpack_public_path__ + "img/VL_13_02.e610cfbf.png";